import StyledErrorBanner from "features/shared/components/banners/styles/StyledErrorBanner.styled";
import styled from "styled-components";

const LoginFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 16px;

  gap: 24px;

  ${StyledErrorBanner} {
    width: 100%;
    padding: 24px;
  }
`;

export default LoginFormContainer;
